<template>
    <Rating/>
</template>

<script>
import { Rating } from 'shared'

export default {
    name: "rating",
    components: {
        Rating
    }
}
</script>